import { Nav, Tab } from "react-bootstrap";
import { IMeetingDetails } from "../../../api/IMeeting";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import LicencesGrid from "../../../leap-components/Licences/LicencesGrid";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  meeting: IMeetingDetails;
}

interface MeetingRelatedComplianceProps {
  meeting: IMeetingDetails;
}

const SubTabs = ({ className, activeKey, meeting }: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="licences">Licences</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="licences">
          <LicencesGrid
            regardingObjectId={meeting.originalmeetingid}
            regardingObjectType={"Meeting"}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid regardingObjectId={meeting.originalmeetingid} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  meeting,
}: MeetingRelatedComplianceProps) => {
  var bodyElements = <SubTabs activeKey="licences" meeting={meeting} />;

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
